"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const bew_localization_1 = require("@skype/bew-localization");
const react_1 = require("@stardust-ui/react");
const BotsContext_1 = require("../../contexts/bots/BotsContext");
const ConfigContext_1 = require("../../contexts/ConfigContext");
class BotInfo extends React.PureComponent {
    render() {
        return React.createElement("section", { className: 'botInfoContainer' },
            React.createElement(BotsContext_1.BotsContextConsumer, null, (botContext) => botContext &&
                React.createElement(React.Fragment, null,
                    React.createElement(ConfigContext_1.ConfigContextConsumer, null, (configContext) => this._renderAvatar(configContext, botContext.botInfo)),
                    botContext.botInfo.isTrusted && React.createElement("div", null,
                        React.createElement(react_1.Text, { size: 'medium', className: 'certified', content: bew_localization_1.localizer.getString('skype_certified') }),
                        React.createElement(ConfigContext_1.ConfigContextConsumer, null, (configContext) => React.createElement(react_1.Image, { src: `${configContext.basePath}/images/AvatarBotCertified.svg`, "aria-hidden": 'true' }))),
                    React.createElement(react_1.Header, { as: 'h2', content: botContext.botInfo.name }),
                    React.createElement(react_1.Header, { as: 'h3', content: botContext.botInfo.developer }))));
    }
    _renderAvatar(configContext, botInfo) {
        const avatarImage = {
            src: botInfo.avatarUrl || `${configContext.basePath}/images/avatar.jpg`,
            styles: { width: '100%', height: '100%', objectFit: 'cover' },
        };
        return React.createElement("div", { style: { position: 'relative' } },
            React.createElement(react_1.Avatar, { styles: { margin: '10px 0px' }, size: 100, image: avatarImage }),
            React.createElement(react_1.Image, { src: `${configContext.basePath}/images/agentMask.svg`, className: 'avatarMask' }));
    }
}
exports.BotInfo = BotInfo;
